import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import TrackingProgress from './TrackingProgress';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, requests, error, message, data,
  } = state.request;
  return {
    isLoading,
    requests,
    error,
    message,
    data,
  };
}

const Styled = withStyles(styles)(TrackingProgress);

export default connect(
  mapStateToProps,
)(Styled);
